import * as React from "react";
import * as ReactDOM from "react-dom";
import "./ShopsComponent.css";
import { T4ShopsComponent } from "./T4ShopsComponent";
import ImageHeader from "../common/imageheader/imageheader";
import T3ShopsComponent from "./T3ShopsComponent";

export interface ShopsComponentState {
    isSpanish: boolean;
    preOrPostSecurity: string;
    t4DropdownVisible: boolean;
    imageDescriptionVisible: boolean;
    activeC: string;

}

export default class ShopsComponent extends React.Component<{}, ShopsComponentState> {
    state: ShopsComponentState;
    private constructor(props: {}) {
        super(props);

        const isSpanish =
            window.location.pathname.slice(0, 4) === "/es" ||
            window.location.pathname.slice(0, 4) === "/es/";

        let sp = new URLSearchParams(window.location.search);
        const _activeC = sp.get("term") === "3" ? "3" : "4";
        const _preOrPost = sp.get("loc") === "Post-Security" ? "Post-Security" : _activeC === "3" ? "Post-Security" : "Pre-Security";
        sp.set('term', _activeC);
        sp.set('loc', _preOrPost)
        window.history.replaceState({}, '', `${window.location.pathname}?${sp}`);
        this.state = {
            isSpanish,
            preOrPostSecurity: _preOrPost,
            t4DropdownVisible: false,
            imageDescriptionVisible: false,
            activeC: _activeC,

        };
    }

    public toggleT4Dropdown = () =>
        this.setState(
            Object.assign(this.state, {
                t4DropdownVisible: !this.state.t4DropdownVisible
            })
        );

    public handleHeaderClick = (n: string, e: string) => {
        this.setState(
            Object.assign(this.state, { activeC: n, preOrPostSecurity: e })
        );
        const params = new URLSearchParams(window.location.search);
        params.set('term', n);
        params.set('loc', e);
        if (n === "3" || e === "Pre-Security") {
            params.delete("gate");
        }
        window.history.replaceState({}, '', `${window.location.pathname}?${params}`);

    };

    public render(): any {
        return (
            <div>
                <div className="row">

                    <ImageHeader
                        imageUrl={"https://www.skyharbor.com/images/default-source/siteimages/page-headers/shops-cover.jpg"}
                        englishText={"SHOPS"}
                        spanishText={"TIENDAS"}
                        isSpanish={this.state.isSpanish}
                    />
                </div>

                <div className="row text-center mt-2 h-100">

                    <div className="col-6 col-md-6 mt-0 py-0 pl-0 pr-1">
                        <div className="row no-gutters pp-light-blue-background h-100">
                            <div
                                className="col-12 py-2 lh-adjust pp-font-blue font-16 font-bold align-self-center"
                                onClick={() => this.handleHeaderClick("3", "Post-Security")}
                                style={
                                    this.state.activeC === "3"
                                        ? { color: "white", textDecoration: "none" }
                                        : {}
                                }>
                                {this.state.isSpanish ? <div>Terminal 3</div> : <div>Terminal 3</div>}
                            </div>
                        </div>
                    </div>
                    <div
                        className="col-6 col-md-6 mt-0 py-0 pl-0 pr-0"
                        onMouseEnter={this.toggleT4Dropdown}
                        onMouseLeave={this.toggleT4Dropdown}>
                        <div className="row no-gutters pp-light-blue-background h-100">
                            <div
                                className="col-12 py-2 lh-adjust pp-font-blue font-16 font-bold align-self-center"
                                onClick={() => this.handleHeaderClick("4", "Pre-Security")}
                                style={
                                    this.state.activeC === "4"
                                        ? { color: "white", textDecoration: "none" }
                                        : {}
                                }>
                                {this.state.isSpanish ? <div>Terminal 4</div> : <div>Terminal 4</div>}
                            </div>
                            <div
                                className={
                                    this.state.t4DropdownVisible
                                        ? "dropdown-holder open"
                                        : "dropdown-holder closed"
                                }
                                style={{ top: "100%" }}>
                                <div
                                    className="dropdown p-2"
                                    style={{
                                        marginLeft: "0px",
                                        marginRight: "0px",
                                        marginTop: "5.0px",
                                        marginBottom: "5.0px",
                                        fontSize: "calc(0.5em + 0.8vw)",
                                        fontWeight: "bold",
                                        border: "none"
                                    }}
                                    onClick={() => this.handleHeaderClick("4", "Pre-Security")}>
                                    {this.state.isSpanish ? "Pre-Security" : "Pre-Security"}
                                </div>
                                <div
                                    className="dropdown p-2"
                                    style={ {
                                        marginLeft: "0px",
                                        marginRight: "0px",
                                        marginBottom: "5.0px",
                                        fontSize: "calc(0.5em + 0.8vw)",
                                        fontWeight: "bold",
                                        border: "none"
                                    }}
                                    onClick={() => this.handleHeaderClick("4", "Post-Security")}>
                                    {this.state.isSpanish ? "Post-Security" : "Post-Security"}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="row pt-2"
                    style={{ paddingLeft: "0.5rem", paddingRight: "0.5rem" }}>
                    <div className="col-12 prepaid-heading p-2">
                        {this.state.preOrPostSecurity}
                    </div>
                </div>
                {this.state.activeC === '3' ? <T3ShopsComponent isSpanish={this.state.isSpanish} preOrPostSecurity={this.state.preOrPostSecurity} />
                    : <T4ShopsComponent isSpanish={this.state.isSpanish} preOrPostSecurity={this.state.preOrPostSecurity} />
                }


            </div>
        );
    }
}

let domContainer = document.querySelector("#shops-comp");
if (!(domContainer === undefined || domContainer === null))
    ReactDOM.render(<ShopsComponent />, domContainer);
